import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {defineCustomElements} from "@trumpf/ux.ui-community/loader";

defineCustomElements();

bootstrapApplication(AppComponent, appConfig);
